/**
 * SafetyEquipment - Safety equipment configuration section
 */

import React from 'react';
import { Checkbox } from '../../../../catalyst/checkbox';

const SafetyEquipment = ({ vesselConfig, updateConfig }) => {
  const handleOptionalEquipmentToggle = (equipment) => {
    const current = vesselConfig.optionalEquipment || [];
    const updated = current.includes(equipment)
      ? current.filter(e => e !== equipment)
      : [...current, equipment];
    updateConfig({ optionalEquipment: updated });
  };

  return (
    <div>
      <h3 className="text-base font-medium text-gray-900 mb-4">Additional Safety Equipment</h3>
      <div className="space-y-4">
        {/* SART */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('sart') || false}
            onChange={() => handleOptionalEquipmentToggle('sart')}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">SART</p>
            <p className="text-sm text-gray-600">Search and Rescue Transponder</p>
          </div>
        </label>

        {/* PLB */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('plb') || false}
            onChange={() => handleOptionalEquipmentToggle('plb')}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">PLB</p>
            <p className="text-sm text-gray-600">Personal Locator Beacons</p>
          </div>
        </label>

        {/* Life Raft */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('life_raft') || false}
            onChange={() => handleOptionalEquipmentToggle('life_raft')}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">Life Raft</p>
            <p className="text-sm text-gray-600">Inflatable life raft</p>
          </div>
        </label>

        {/* Immersion Suits */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('immersion_suits') || false}
            onChange={() => handleOptionalEquipmentToggle('immersion_suits')}
            disabled={vesselConfig.policeBoat}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">
              Immersion Suits
              {vesselConfig.policeBoat && (
                <span className="ml-2 text-xs text-blue-600">(Required for police boats)</span>
              )}
            </p>
            <p className="text-sm text-gray-600">Thermal protective suits</p>
          </div>
        </label>

        {/* Thermal Protective Aids */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('tpa') || false}
            onChange={() => handleOptionalEquipmentToggle('tpa')}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">Thermal Protective Aids</p>
            <p className="text-sm text-gray-600">TPAs for liferafts</p>
          </div>
        </label>

        {/* Gas Detection */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('gas_detection') || false}
            onChange={() => handleOptionalEquipmentToggle('gas_detection')}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">Gas Detection System</p>
            <p className="text-sm text-gray-600">Fixed or portable gas detectors</p>
          </div>
        </label>

        {/* MOB Recovery */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('mob_recovery') || false}
            onChange={() => handleOptionalEquipmentToggle('mob_recovery')}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">MOB Recovery Equipment</p>
            <p className="text-sm text-gray-600">Jason's Cradle or similar</p>
          </div>
        </label>

        {/* Defibrillator */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('defibrillator') || false}
            onChange={() => handleOptionalEquipmentToggle('defibrillator')}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">Defibrillator (AED)</p>
            <p className="text-sm text-gray-600">Automated external defibrillator</p>
          </div>
        </label>

        {/* Stretcher */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('stretcher') || false}
            onChange={() => handleOptionalEquipmentToggle('stretcher')}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">Stretcher</p>
            <p className="text-sm text-gray-600">Emergency evacuation stretcher</p>
          </div>
        </label>

        {/* General Alarm - May be auto-required */}
        <label className="flex items-start gap-3">
          <Checkbox
            checked={vesselConfig.optionalEquipment?.includes('general_alarm') || false}
            onChange={() => handleOptionalEquipmentToggle('general_alarm')}
            disabled={vesselConfig.autoRequiredGeneralAlarm}
            className="mt-0.5"
          />
          <div>
            <p className="font-medium text-gray-900">
              General Alarm
              {vesselConfig.autoRequiredGeneralAlarm && (
                <span className="ml-2 text-xs text-blue-600">(Auto-required)</span>
              )}
            </p>
            <p className="text-sm text-gray-600">Emergency alarm system</p>
          </div>
        </label>
      </div>
    </div>
  );
};

export default SafetyEquipment;